module.exports = __webpack_public_path__ + "static/media/duncan.075a4c6e.jpg";